import React from 'react';
import styles from '../Modal.module.scss';
import { INewModal } from '../Modal';

export const ModalClose: React.FC<INewModal> = ({ onClose }) => (
    <button data-testid="modal-close" className={styles.modalClose} onClick={onClose} />
);
